import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export function createPDF(
  uploader,
  survey,
  participant,
  surveyDefinition,
  questions,
  onSuccess = undefined
) {
  const multipleChoice = (q) => {
    const qlist = q.choices.map((c) => {
      const answer = c.value === survey.data[q.name] ? 'x' : '-'
      return [answer, c]
    })
    return {
      style: 'questionTable',
      table: {
        widths: ['*', 450],
        body: [[{ text: q.title, colSpan: 2, style: 'subheader' }, '']].concat(
          qlist
        ),
      },
    }
  }

  const comment = (q) => {
    return {
      style: 'questionTable',
      table: {
        widths: [500],
        body: [[{ text: q.title, style: 'subheader' }], [survey.data[q.name]]],
      },
    }
  }

  const expression = (q) => {
    return {
      style: 'questionTable',
      table: {
        widths: [500],
        body: [[survey.data[q.name]]],
      },
    }
  }

  const questionDefinitions = questions.map((q) => {
    switch (q.type) {
      case 'radiogroup':
        return multipleChoice(q)
        break
      case 'comment':
        return comment(q)
        break
      case 'text':
        return comment(q)
        break
      case 'dropdown':
        return comment(q)
        break
      case 'expression':
        return expression(q)
        break
    }
  })

  const dd = {
    content: [
      {
        text: surveyDefinition.structure.title,
        style: 'header',
      },
      {
        style: 'questionTable',
        table: {
          widths: [200, '*'],
          body: [
            [{ text: 'Participant', style: 'subheader', colSpan: 2 }, ' '],
            ['Student id', participant.studentId],
          ],
        },
      },
    ].concat(questionDefinitions),
    styles: {
      questionTable: {
        margin: [0, 5, 0, 15],
      },
      header: {
        fontSize: 20,
        bold: true,
        margin: [0, 5, 0, 15],
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5],
      },
    },
  }

  const pdfDocGenerator = pdfMake.createPdf(dd)

  pdfDocGenerator.getBlob((blob) => {
    uploader.handleSelectFile(
      blob,
      undefined,
      surveyDefinition.fileName + '.pdf' || 'survey.pdf',
      onSuccess
    )
  })
}
